import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withStyles, withTheme, Paper, Typography, FormControlLabel, Checkbox, Box, Button } from "@material-ui/core";
import { fetchForms, deployForms, fetchAccreditationDetailForms, fetchQADetailForms } from "../actions"; // Assuming this action exists

const styles = (theme) => ({
  paper: theme.paper.paper,
  title: theme.paper.title,
  page: theme.page,
});

class FormsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formToPublish: [],
    };
  }

  componentDidMount() {
    const { formType, accId, detailType } = this.props;
    if (formType) {
      this.props.fetchForms(formType);
    }
    if (accId && detailType === "acc") {
      this.props.fetchAccreditationDetailForms(accId);
    }
    if (accId && detailType === "qa") {
      this.props.fetchQADetailForms(accId);
    }
  }

  componentDidUpdate(prevProps) {
    const { accId, detailType } = this.props;
    if (accId !== prevProps.accId || detailType !== prevProps.detailType) {
      if (accId && detailType === "acc") {
        this.props.fetchAccreditationDetailForms(accId);
      }
      if (accId && detailType === "qa") {
        this.props.fetchQADetailForms(accId);
      }

      // Optional: Reset local form state
      this.setState({ formToPublish: [] });
    }
  }

  handleCheckboxChange = (uuid, isDisabled) => {
    if (isDisabled) return;
    this.setState(({ formToPublish }) => ({
      formToPublish: formToPublish.includes(uuid)
        ? formToPublish.filter((id) => id !== uuid)
        : [...formToPublish, uuid],
    }));
  };

  handleDeployForms = () => {
    const { uuid, deployForms, detailType } = this.props;
    const { formToPublish } = this.state;
    deployForms(formToPublish, uuid, detailType, "Deployed Forms");
  };

  isDeployForms = () => !this.state.formToPublish.length || !this.props.uuid;

  render() {
    const { classes, forms, qaDetailsForms, accreditationDetailsForms } = this.props;
    const { formToPublish } = this.state;

    // Auto Refresh the page
    const handleEvent = () => {
      window.location.reload();
    };

    // Extract quality_assurance_and_accreditation form UUIDs for comparison
    const accreditedFormUUIDs = Array.isArray(accreditationDetailsForms)
      ? new Set(accreditationDetailsForms?.map((edge) => edge.odkForm.uuid))
      : new Set(qaDetailsForms?.map((edge) => edge.odkForm.uuid));

    return (
      <div>
        <Paper className={classes.paper}>
          <Typography className={classes.title}>Forms List</Typography>
          <div className={classes.page}>
            {forms?.map((form, index) => {
              const isChecked = accreditedFormUUIDs?.has(form?.uuid);
              return (
                <div style={{ width: "100%" }} key={index}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        value={form?.uuid}
                        onChange={() => this.handleCheckboxChange(form?.uuid, isChecked)}
                        checked={isChecked || formToPublish.includes(form?.uuid)}
                        disabled={isChecked}
                      />
                    }
                    label={form?.formName}
                  />
                </div>
              );
            })}
            <Box display={"flex"} justifyContent={"end"}>
              <Button
                variant={"contained"}
                onClick={() => {
                  this.handleDeployForms();
                  handleEvent();
                }}
                color="primary"
                disabled={this.isDeployForms()}
              >
                Publish Forms
              </Button>
            </Box>
          </div>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  forms: state.quality_assurance_and_accreditation.forms,
  accreditationDetailsForms: state.quality_assurance_and_accreditation.accreditationDetailsForms,
  fetchingAccreditationDetailsForms: state.quality_assurance_and_accreditation.fetchingAccreditationDetailsForms,
  fetchedAccreditationDetailsForms: state.quality_assurance_and_accreditation.fetchedAccreditationDetailsForms,
  errorAccreditationDetailsForms: state.quality_assurance_and_accreditation.errorAccreditationDetailsForms,
  fetchingQADetailsForms: state.quality_assurance_and_accreditation.fetchingQADetailsForms,
  fetchedQADetailsForms: state.quality_assurance_and_accreditation.fetchedQADetailsForms,
  qaDetailsForms: state.quality_assurance_and_accreditation.qaDetailsForms,
  errorQADetailsForms: state.quality_assurance_and_accreditation.errorQADetailsForms,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchForms, deployForms, fetchAccreditationDetailForms, fetchQADetailForms }, dispatch);

export default withTheme(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(FormsList)));
